__turbopack_context__.v({
  "header": "UserModelsTable-module-scss-module__afbDHG__header",
  "scrolled": "UserModelsTable-module-scss-module__afbDHG__scrolled",
});
